var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"r-initials-icon text-body-3",class:[_vm.bgClass, _vm.colorClass],style:({ '--size': _vm.size })},[(_vm.initials)?[_vm._v(_vm._s(_vm.initials))]:_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }